import React from 'react';
import { Empty } from 'antd';

import styles from './EmptyNotes.scss';

const EmptyNotes = () => (
  <div className={styles['c-empty-notes']}>
    <div className={styles['c-empty-notes__header']}>
      <h3 className={styles['c-empty-notes__header-text']}>Your Notes</h3>
    </div>
    <div className={styles['c-empty-notes__body']}>
      <Empty description="There are no notes for this interview." />
    </div>
  </div>
);

export default EmptyNotes;
